import { Theme } from '@mui/material/styles';

import Button from './Button';
import Menu from './Menu';

export default function ComponentsOverrides(theme: Theme) {
  return Object.assign(Button(theme), Menu());
}
